/**
 * Преобразует массив медиа-объектов из API в массив File-объектов.
 * @param apiMedia - Массив объектов, полученных от сервера.
 * @returns Массив объектов File.
 */
export default async (
  apiMedia: Array<{ file: string; type: string; name?: string }>,
): Promise<File[]> => {
  // Проверяем, что массив не пустой
  if (!apiMedia || apiMedia.length === 0) {
    return [];
  }

  // Используем Promise.all, чтобы дождаться загрузки всех файлов параллельно
  const files = await Promise.all(
    apiMedia.map(async (mediaItem) => {
      try {
        const response = await fetch(mediaItem.file);
        if (!response.ok) {
          // Создаем текст ошибки, чтобы понять, что прислал сервер
          // const errorText = await response.text();
          // console.error(`Сервер вернул ошибку ${response.status} для URL: ${mediaItem.file}`);
          // console.error('Ответ сервера:', errorText); // Здесь вы увидите HTML-страницу ошибки
          throw new Error(`Ошибка ${response.status} при загрузке файла.`);
        }

        // Проверяем, что тип контента соответствует ожидаемому
        const contentType = response.headers.get('content-type');
        if (contentType && !contentType.startsWith(mediaItem.type.split(';')[0])) {
          console.warn(`Ожидали: ${mediaItem.type}, получили: ${contentType}`);
        }
        // 2. Получаем бинарные данные (ArrayBuffer)
        const buffer = await response.arrayBuffer();

        // 3. Создаем Blob из данных. Используем имя файла из API, если оно есть,
        //    иначе генерируем его из URL.
        const fileName = mediaItem.name || mediaItem.file.split('^').pop() || 'file';

        const blob = new Blob([buffer], { type: mediaItem.type });

        // 4. Создаем и возвращаем объект File
        return new File([blob], fileName, { type: mediaItem.type });
      } catch (error) {
        // console.error('Ошибка при преобразовании файла:', error);
        // В случае ошибки можно вернуть заглушку или просто пропустить файл
        return null;
      }
    }),
  );

  // Фильтруем возможные null-значения (если были ошибки при загрузке)
  return files.filter((file): file is File => file !== null);
};
